goog.require('el8.template.multiuser_access.signup');
goog.require('el8.shared.util.passwordHelp');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');
goog.require('el8.service.tooltip');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.signup = (function() {

    var that = {};
    var theForm = null;

    var hasAnyTargetPhysician;
    var verificationId = null;
    var verificationToken = null;
    var unauthUserId = null;
    var authToken = null;
    var isMedicalGroup = null;
    var passwordHelp = null;

    function goToChart(faxCode) {
        // signup and go to chart
        var person = extractModelFromForm();

        // we need these token when the user is trying to sign up in a practice within existing users
        person.verificationId = verificationId;
        person.verificationToken = verificationToken;
        person.unauthUserId = unauthUserId;
        person.authToken = authToken;

        // disable the button
        $('#go-to-chart').prop('disabled', true);
        $('#go-to-chart').html('Accessing Chart.  Please wait ...');



        // distinct event for easier tracking


        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('createAccount', [faxCode]),
            data: JSON.stringify(person),
            async: true,
            success: function(data) {
                if (!data.error) {
                    location.href=data.location;
                } else {
                    location.href='/efax/error/';
                }
            }
        });
    }

    function inputChanged() {
        // called when any input value changed
        var person = extractModelFromForm();
        renderFormFromModel(person);
    }

    var debouncedInputChanged = _.debounce(inputChanged, 250);

    function extractModelFromForm() {
        // extract all the input from the form to create the model
        var person = {
            role : theForm.getVal('role'),
            firstName : theForm.getVal('firstName'),
            lastName : theForm.getVal('lastName'),
            physicianId : theForm.getVal('physicianId'),
            designation : theForm.getVal('designation'),
            password1 : theForm.getVal('password1'),
            password2 : theForm.getVal('password2'),
            question : theForm.getVal('question'),
            answer : theForm.getVal('answer')
        };
        return person;
    }

    function hasPassword(person) {
        return person.password1 && person.password2;
    }

    function passwordMatches(person) {
        return hasPassword(person) && person.password1 === person.password2;
    }

    function passwordOk(person) {
        // passpord policy
        return passwordHelp.passwordCheck1(person.password1) && passwordHelp.passwordCheck2(person.password1);
    }

    function hasQA(person) {
        return person.question && person.answer;
    }

    function isPersonComplete(person) {
        if (!passwordMatches(person) || !passwordOk(person) || !hasQA(person)) {
            return false;
        }

        // check if we have a complete person model
        if (person.role === 'staff') {
            return person.firstName && person.lastName;
        } else {
            if (!person.physicianId) {
                return person.firstName && person.lastName;
            }
        }
        return true;
    }

    function fieldState(ele, fieldValue) {
        if (fieldValue) {
            fieldOk(ele);
        } else {
            fieldPending(ele);
        }
    }

    function fieldOk(ele) {
        if (!ele) {
            return;
        }
        ele.removeClass("el8FormError").addClass("el8FormSuccess");
    }

    function fieldPending(ele) {
        if (!ele) {
            return;
        }
        ele.removeClass("el8FormError").removeClass("el8FormSuccess");
    }

    function fieldError(ele) {
        if (!ele) {
            return;
        }
        ele.removeClass("el8FormSuccess").addClass("el8FormError");
    }

    function renderFormFromModel(person) {
        // take the person model and make sure the form reflects the model correctly
        // if role is staff, hide the selection of physicians
        if (person.role === 'staff') {
            $('#signup-physician-chooser-container').hide();
            $('#signup-designation-container').hide();
            $('#signup-name-container').show();
        } else {
            $('#signup-physician-chooser-container').show();
            $('#signup-designation-container').show();

            // if "other" is selected, show the firstname/lastname fields
            if (!person.physicianId) {
                $('#signup-name-container').show();
                $('#signup-designation-container').show();
            } else {
                $('#signup-name-container').hide();
                $('#signup-designation-container').hide();
            }
        }

        fieldState($(':input[name="firstName"]').parent(), person.firstName);
        fieldState($(':input[name="lastName"]').parent(), person.lastName);
        fieldState($(':input[name="answer"]').parent(), person.answer);

        if (hasPassword(person)) {
            if (passwordOk(person) && passwordMatches(person)) {
               fieldOk($(':input[name="password1"]').parent());
               fieldOk($(':input[name="password2"]').parent());
            } else {
               fieldError($(':input[name="password1"]').parent());
               fieldError($(':input[name="password2"]').parent());
            }
        }


        if (isPersonComplete(person)) {
            $('#go-to-chart').prop('disabled', false);
        } else {
            $('#go-to-chart').prop('disabled', true);
        }

        if (!hasAnyTargetPhysician) {
            // if there isnt any pre-filled physician, dont ever show the chooser
            $('#signup-physician-chooser-container').hide();
        }
    }

    function setupForm() {
        var fields = [];
        fields = fields.concat([
            {
                name: 'role',
                selector: ':input[name="role"]',
                changeFn: function() {
                    $('.detail-container').show();
                    inputChanged();
                }
            },
            {
                name: 'firstName',
                selector: ':input[name="firstName"]',
                maxLength: 30,
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'lastName',
                selector: ':input[name="lastName"]',
                maxLength: 30,
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'physicianId',
                selector: ':input[name="physicianId"]',
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'designation',
                selector: ':input[name="designation"]',
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'password1',
                selector: ':input[name="password1"]',
                maxLength: 12,
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'password2',
                selector: ':input[name="password2"]',
                maxLength: 12,
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'question',
                selector: ':input[name="question"]',
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'answer',
                selector: ':input[name="answer"]',
                maxLength: 30,
                changeFn: function() {
                    inputChanged();
                }
            }
        ]);

        var form = new el8.uiwidget.Form({
            fields: fields,
            container: $('#main-form')
        });
        form.render();
        return form;
    }

    function initializeTooltips() {
        el8.service.tooltip.create({
            anchor: $('.password-icon'),
            text: el8.template.multiuser_access.signup.passwordTooltip()
        });
        el8.service.tooltip.create({
            anchor: $('.securityQ-icon'),
            text: el8.template.multiuser_access.signup.securityQTooltip()
        });
    }

    function setupKeyPressedListeners() {
        var selectors = [
            ':input[name="password1"]',
            ':input[name="password2"]',
            ':input[name="firstName"]',
            ':input[name="lastName"]',
            ':input[name="answer"]'
        ];
        $(document).on('keydown', selectors.join(', '), debouncedInputChanged);
    }

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */

        if (spec.urls) { el8.service.urls.init(spec.urls); }

        isMedicalGroup = spec.isMedicalGroup;

        $('.main-content').html(
            el8.template.multiuser_access.signup.content({
                'securityQuestions': spec.securityQuestions
            })
        );

        hasAnyTargetPhysician = (spec.intendedPhysician !== null || spec.otherCanonicalPhysicians.length > 0);

        var faxCode = spec.faxCode;

        if (hasAnyTargetPhysician) {
            // show the intended recipient only if there is one and that it's not a medical group
            // for medical group, we have to force the user to sign up as a person (pick a canonical profile or enter first/last)
            $('#signup-physician-selection-container').html(
                el8.template.multiuser_access.signup.physicianNamesSelection({
                    intendedPhysician: spec.intendedPhysician,
                    otherCanonicalPhysicians: spec.otherCanonicalPhysicians
                })
            );
        }

        theForm = setupForm();

        $('.detail-container').hide();

        if (hasAnyTargetPhysician) {
            if (spec.intendedPhysician) {
                theForm.setVal('physicianId', spec.intendedPhysician.id);
            } else {
                theForm.setVal('physicianId', '');
            }
        }

        passwordHelp = el8.shared.util.passwordHelp;
        passwordHelp.init(theForm);
        passwordHelp.setupPasswordHelp();
        initializeTooltips();

        setupKeyPressedListeners();

        $(document).on('click', '.eula-link', function(e) {
            window.open('https://www.elationemr.com/eula/','_blank');
            e.preventDefault();
            return false;
        });

        $(document).on('click', '#go-to-chart', function() {
            goToChart(faxCode);
        });

    };

    that.filloutProfile = function(spec) {
        if (spec.firstName) {
            theForm.setVal('firstName', spec.firstName);
        }
        if (spec.lastName) {
            theForm.setVal('lastName', spec.lastName);
        }
        if (spec.designation) {
            theForm.setVal('designation', spec.designation);
        }
        if (spec.role === 'staff') {
            theForm.setVal('role', 'staff');
        } else {
            theForm.setVal('role', 'clinician');
            if (spec.selectedPhysician) {
                theForm.setVal('physicianId', spec.selectedPhysician);
            } else if (spec.selectedCanonical) {
                theForm.setVal('physicianId', spec.selectedCanonical);
            }
        }
    };

    that.setSignupToken = function(spec) {
        verificationId = spec.verificationId;
        verificationToken = spec.verificationToken;
        unauthUserId = spec.unauthUserId;
        authToken = spec.authToken;
    };

    return that;

})();
